import { Button } from "@mui/material"
import { t } from "i18next"

interface CancelButtonProps {
    onClick: () => void
}
const CancelButton = (props: CancelButtonProps) => {
    const { onClick } = props
    return (
        <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={onClick}>
            { t(`back`, {ns: `common`}) }
        </Button>
    )
}

export { CancelButton }
export type { CancelButtonProps }
